var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "role": "group",
      "aria-labelledBy": _vm.title ? _vm.id + 'Title' : null,
      "aria-describedby": _vm.helpText ? _vm.id + 'HelpText' : null
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "Polaris-FormLayout__Title",
    attrs: {
      "id": _vm.id + 'Title'
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('polaris-form-layout-group-item-wrapper', [_vm._t("default")], 2), _vm._v(" "), (_vm.helpText || _vm.$slots.helpText) ? _c('div', {
    staticClass: "Polaris-FormLayout__HelpText",
    attrs: {
      "id": _vm.id + 'helpText'
    }
  }, [_vm._t("helpText", [_vm._v("\n            " + _vm._s(_vm.helpText) + "\n        ")])], 2) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0875e502", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0875e502","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisFormLayoutGroup.vue
// module id = 283
// module chunks = 0